import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sc3MessageCheckerState } from './sc3-message-checker.state';
import { Sc3ErrorMessageListCheck, Sc3ErrorMessageListInitialState } from './sc3-message-checker.actions';
import { DataQualityErrorMessage, MessageCheckerFacade } from '../models/message-checker.model';

@Injectable({ providedIn: 'root' })
export class Sc3MessageCheckerFacade implements MessageCheckerFacade {
  errorMessages$: Observable<DataQualityErrorMessage> = this.store.select(
    Sc3MessageCheckerState.getSc3ErrorMessageList,
  );
  loaded$: Observable<boolean> = this.store.select(Sc3MessageCheckerState.getLoaded);

  constructor(private store: Store) {}

  checkMessage(message: string): void {
    this.store.dispatch(new Sc3ErrorMessageListCheck(message));
  }

  setInitialState(): void {
    this.store.dispatch(new Sc3ErrorMessageListInitialState());
  }
}
